import React from 'react';
import Layout from '../components/Layout/LandingPage/Layout';

export default function LandingPage(){
    return(
        <Layout />
    )
}